import type { StationGenre } from '~/types/stations'
import type { PodcastCategory } from '~/types/podcasts'

export function useStationsGenres(limit = 10) {
  const nuxtApp = useNuxtApp()

  return useAsyncData(
    `stations-genres-${limit}`,
    (): Promise<StationGenre[]> =>
      $fetch(`/api/stations/genres/`, {
        query: {
          limit: limit,
        },
      }),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}

export function usePodcastsCategories(limit = 150) {
  const nuxtApp = useNuxtApp()

  return useAsyncData(
    `podcasts-genres-${limit}`,
    (): Promise<PodcastCategory[]> =>
      $fetch(`/api/podcasts/categories/`, {
        query: {
          limit: limit,
        },
      }),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}
